// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer___ApHf","Open":"SideDrawer_Open__1stE4","Close":"SideDrawer_Close__1I6d_"};